<template>
  <div class="text-center">
    <b-card
      :img-src="require('@/assets/images/banner/blog-bk.jpg')"
      img-top
      body-class="p-0"
      title="المكتبة الرقمية"
      sub-title="أكبر مكتبة رقمية"
      overlay
      text-variant="white"
    >
    </b-card>

    <b-card>
      <div class="row mb-3 mt-3">
        <div class="col-md-9">
          <b-input-group>
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              :placeholder="$t(`site.search`)"
              v-model="search"
              @input="(val) => searchChange(val)"
            />
          </b-input-group>
        </div>
        <div class="col-3">
          <div class="float-md-right pt-1">
            <span class="text-muted text-small mr-1 mb-2">
              {{ from }}:{{ to }}
            </span>

            <b-dropdown
              id="ddown2"
              right
              :text="`${perPage}`"
              variant="outline-warning"
              size="xs"
            >
              <b-dropdown-item
                v-for="(size, index) in [5, 10, 20, 50, 100]"
                :key="index"
                @click="changePageSize(size)"
                >{{ size }}</b-dropdown-item
              >
            </b-dropdown>
            <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
          </div>
        </div>
      </div>
    </b-card>
    <b-card>
      <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
        <div class="row">
          <div class="col-md-12">
            <b-table :stacked="($mobile==1)" 
              ref="table"
              class="vuetable"
              sort-by="id"
              sort-desc.sync="false"
              :current-page="currentPage"
              :fields="bootstrapTable.fields"
              :items="dataProvider"
            >
              <template #cell(link)="data">
                <b-link
                  :to="{ name: 'LibraryDetails', params: { id: data.item.id } }"
                >
                  رابط المحتوي
                </b-link>
              </template>
            </b-table>
            <!-- end of table -->
            <hr />
            <b-pagination
              align="right"
              class="
                dataTables_paginate
                paging_simple_numbers
                pagination-warning
              "
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            >
              <template v-slot:next-text>
                <i class="fas fa-angle-left" />
              </template>
              <template v-slot:prev-text>
                <i class="fas fa-angle-right" />
              </template>
              <template v-slot:first-text>
                <i class="fas fa-step-forward" />
              </template>
              <template v-slot:last-text>
                <i class="fas fa-step-backward" />
              </template>
            </b-pagination>
          </div>
          <!-- end of col -->
        </div>
        <!-- end of row -->
      </div>
    </b-card>
  </div>
</template>

<script>
import controller from "../../../Controllers/LibraryController";
import config from "../../../config/config";
export default {
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "id", label: "ID", sortable: false },
          {
            key: "title",
            label: "عنوان المحتوى	",
            sortable: true,
          },
          {
            key: "file_setting.type",
            label: "نوع المحتوى	",
            sortable: true,
          },
          {
            key: "category.name",
            label: "إسم التصنيف	",
            sortable: true,
          },

          {
            key: "link",
            label: "رابط المحتوي",
          },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
    };
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      apiParams.with = ["licenses", "category", "fileSetting"];
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
  },
};
</script>

<style>
</style>